import { createContext } from 'react';

export const LayoutContext = createContext({});

export const LayoutProvider = (props) => {
  const {
    children,
    resourceData,
    websiteSectionList,
    catalogList,
    isMro,
    indexPage = false,
    onlySScreen = false, // 只兼容小屏幕
    globalSearchKeyword,
    showMemberWebsite,
    showFriendWebsite,
  } = props;

  return (
    <LayoutContext.Provider
      value={{
        resourceData,
        websiteSectionList,
        catalogList,
        isMro,
        indexPage,
        onlySScreen,
        globalSearchKeyword,
        showMemberWebsite,
        showFriendWebsite,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};
